import { Component, inject, ViewChild } from '@angular/core';
import { MatTabNavPanel } from '@angular/material/tabs';
import { RouterSelectors } from '@next/core-lib/router-store';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';

import { SiteState } from 'src/app/shared/models/shared.model';

import { getSelectedContactpersonId } from '../../../contactperson/store/contactperson.selectors';

@Component({
  selector: 'app-contactperson-navigation',
  templateUrl: './contactperson-navigation.component.html',
  standalone: false,
})
export class ContactpersonNavigationComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  @ViewChild('tabPanel') tabPanel: MatTabNavPanel;

  contactpersonId$: Observable<number> = this.store.select(getSelectedContactpersonId);

  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getUrl));

  isAuthorizations$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('authorizations') > 0),
  );
  isRelations$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('relations') > 0),
  );
  isDetails$: Observable<boolean> = this.isAuthorizations$.pipe(
    withLatestFrom(this.isRelations$),
    switchMap(([isAuthorizations, isRelations]) => [!(isAuthorizations || isRelations)]),
  );
}
